<template>
  <div v-scroll="onScroll">
    <activity-card
      v-for="activity in activities"
      :id="activity.id"
      :key="activity.id"
      :activity="activity"
    />
  </div>
</template>

<script>

import ActivityCard from '@/components/feed/ActivityCard'
import EmptyContent from '~/components/utils/EmptyContent'
export default {
  components: {
    ActivityCard,
    EmptyContent
  },
  props: {
    extraParams: {
      type: [String],
      required: false,
      default: ''
    },
    type: {
      type: [String],
      required: false,
      default: 'home'
    }
  },
  data() {
    return {
      activities: [],
      feed_scroll: '',
      feed_loader: true,
      feed_length: 10
    }
  },
  computed: {
    homeFeed() {
      if (this.$route.fullPath == '/') {
        return true
      }
      return false
    }
  },
  async mounted() {
    const activities = this.$axios
      .$get('api/v1/list_news_feed/' + this.extraParams)
      .then(res => {
        this.activities = res
        if (this.$device.isMobile) {
          this.feed_length = 5
        } else {
          this.feed_length = 10
        }
        if (this.activities.length <= this.feed_length) {
          this.feed_loader = false
        }
      })
  },
  methods: {
    onScroll(e) {
      this.feed_scroll =
        window.pageYOffset || document.documentElement.scrollTop
      this.feed_scroll = this.feed_scroll + window.innerHeight
      const height = document.documentElement.offsetHeight
      if (height - this.feed_scroll == 0 && this.activities.length > 0) {
        const length = this.activities.length - 1
        const last_id = this.activities[length].id
        let url = ''
        if (this.extraParams) {
          url =
            '/api/v1/list_news_feed/list_news_feed/' +
            this.extraParams +
            '&last_id=' +
            last_id
        } else {
          url = '/api/v1/list_news_feed/list_news_feed/?last_id=' + last_id
        }
        const activities = this.$axios.$get(url).then(res => {
          if (res.length == 0) {
            this.feed_loader = false
          }
          this.activities = this.activities.concat(res)
        })
      }
    }
  }
}
</script>
